// Documentation navigation structure. Each `id` maps to a Markdown file at
// `public/docs/<id>.md` (fetched at runtime). Articles without a Markdown file
// fall back to an "in progress" placeholder — don't list an article here
// until its file exists. `time` is words / 180, rounded. `badge` mirrors the
// product: 'beta' — behind a beta flag, 'скоро' — marked «Скоро» in the menu.
// A new article also goes into public/sitemap.xml.

export interface DocItem {
  id: string;
  title: string;
  time: string;
  badge?: string;
}

export interface DocGroup {
  group: string;
  items: DocItem[];
}

export const DOCS_NAV: DocGroup[] = [
  {
    group: 'Начало',
    items: [
      { id: 'intro', title: 'Что такое SkillScape', time: '4 мин' },
      { id: 'changelog', title: 'Что нового', time: '4 мин' },
      { id: 'first-steps', title: 'Первый вход и профиль', time: '5 мин' },
      { id: 'roles', title: 'Роли в системе', time: '5 мин' },
      { id: 'glossary', title: 'Термины и понятия', time: '7 мин' },
    ],
  },
  {
    group: 'Компетенции',
    items: [
      { id: 'maps', title: 'Карты компетенций', time: '6 мин' },
      { id: 'grades', title: 'Грейды и уровни', time: '4 мин' },
      { id: 'confirmation', title: 'Подтверждение компетенций', time: '5 мин', badge: 'beta' },
    ],
  },
  {
    group: 'Performance Review',
    items: [
      { id: 'pr-flow', title: 'Как устроен раунд', time: '4 мин' },
      { id: 'self', title: 'Self-эссе', time: '3 мин' },
      { id: 'peer', title: 'Peer-обратная связь', time: '4 мин' },
      { id: 'summary', title: 'Саммари и итоги', time: '4 мин' },
    ],
  },
  {
    group: 'Эссе и квартальные итоги',
    items: [
      { id: 'essays', title: 'Месячные эссе', time: '5 мин', badge: 'beta' },
      { id: 'quarterly-reports', title: 'Квартальные отчёты', time: '4 мин' },
      { id: 'quarterly-scoring', title: 'Квартальная оценка', time: '4 мин' },
    ],
  },
  {
    group: 'Review 360°',
    items: [
      { id: '360-cycles', title: 'Цикл 360°', time: '5 мин' },
      { id: '360-templates', title: 'Шаблоны опросов', time: '4 мин' },
    ],
  },
  {
    group: 'Цели и обучение',
    items: [
      { id: 'goals', title: 'Цели', time: '4 мин' },
      { id: 'learning', title: 'Обучение', time: '5 мин', badge: 'скоро' },
    ],
  },
  {
    group: 'Календарь и уведомления',
    items: [
      { id: 'calendar', title: 'Календарь', time: '4 мин', badge: 'beta' },
      { id: 'notifications', title: 'Уведомления', time: '4 мин' },
    ],
  },
  {
    group: 'Администрирование',
    items: [
      { id: 'admin-rounds', title: 'Управление раундами', time: '7 мин' },
      { id: 'admin-users', title: 'Пользователи и команды', time: '4 мин' },
      { id: 'admin-roles', title: 'Роли и права', time: '3 мин', badge: 'beta' },
      { id: 'admin-org', title: 'Настройки организации', time: '4 мин' },
      { id: 'import-export', title: 'Импорт и экспорт', time: '4 мин' },
    ],
  },
  {
    group: 'API и интеграции',
    items: [
      { id: 'api', title: 'REST API · обзор', time: '5 мин' },
      { id: 'essay-import-api', title: 'API импорта эссе', time: '6 мин' },
    ],
  },
];

export const DOCS_NAV_FLAT: DocItem[] = DOCS_NAV.flatMap((g) => g.items);

export const findDocItem = (id: string): DocItem | undefined =>
  DOCS_NAV_FLAT.find((i) => i.id === id);

export const findDocGroup = (id: string): string =>
  DOCS_NAV.find((g) => g.items.some((i) => i.id === id))?.group ?? '';
